// BCM-898 · Goods Receipt Dashboard — documents-pending card (PA1/PA7/PA12).
// Matches the mockup (slides 6, 22, 33): a peach information banner, an optional
// reminder line, then EVERY configured (activated) document as a full-width status
// bar — green "RECEIVED" or red "NOT RECEIVED" (doc rev V3). Informational only.
import React from "react";
import { Typography, CircularProgress, Box } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { useGRStyles } from "../../goodsReceiptStyles";
import useDocumentsPending from "../../hooks/useDocumentsPending";

const DocumentsPendingCard = ({ row, category, title, successTitle, reminderSentOn, viewOnly }) => {
  const classes = useGRStyles();
  const { rows, loading, configuredUnavailable, allReceived } = useDocumentsPending({
    vendorMosymphonyID: row && row.vendorMosymphonyID,
    schrockenDeliveryScheduleBatchID: row && row.schrockenDeliveryScheduleBatchID,
    category,
  });

  return (
    <div className={classes.section} style={viewOnly ? { opacity: 0.85 } : undefined}>
      {allReceived ? (
        // Success state — every configured document has been received.
        <div className={classes.bannerSuccess}>
          <Typography className={classes.bannerTitleSuccess}>
            <CheckCircleIcon style={{ fontSize: 18 }} />
            {successTitle || "All required documents have been received"}
          </Typography>
          <Typography className={classes.bannerSubSuccess}>
            All documents below are received. The batch can move forward.
          </Typography>
        </div>
      ) : (
        <div className={classes.banner}>
          <Typography className={classes.bannerTitle}>
            <WarningRoundedIcon style={{ fontSize: 18 }} />
            {title}
          </Typography>
          <Typography className={classes.bannerSub}>
            Batch cannot move forward and IBD/GRN cannot be generated unless the pending
            documents below are received.
          </Typography>
          {reminderSentOn && (
            <Typography className={classes.bannerReminder}>
              <MailOutlineIcon style={{ fontSize: 15 }} />
              Reminder email notification sent to CMO on {reminderSentOn}
            </Typography>
          )}
        </div>
      )}

      {configuredUnavailable && (
        <div className={classes.depNote}>
          The configured-document list requires backend dependency D2a
          (fetchDocumentTypes on the role router). Showing received documents only
          until it is available.
        </div>
      )}

      {loading ? (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress size={22} />
        </Box>
      ) : rows.length === 0 ? (
        <Typography variant="body2" style={{ color: "#777" }}>
          No documents to display.
        </Typography>
      ) : (
        rows.map((doc, i) => (
          <div
            key={`${doc.name}-${i}`}
            className={`${classes.docBar} ${doc.received ? classes.docBarReceived : classes.docBarPending}`}
          >
            <span className={classes.docName}>
              {doc.received ? (
                <CheckCircleIcon style={{ fontSize: 18, color: "#1E7B34" }} />
              ) : (
                <CancelIcon style={{ fontSize: 18, color: "#C0392B" }} />
              )}
              {doc.name}
            </span>
            <span className={doc.received ? classes.statusReceived : classes.statusPending}>
              {doc.received ? "RECEIVED" : "NOT RECEIVED"}
            </span>
          </div>
        ))
      )}
    </div>
  );
};

export default DocumentsPendingCard;
